var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2Locker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM32 29.77h4a2 2 0 114 0c0 1-.26 1.15-1.24 1.69a4.4 4.4 0 00-2.76 4v1.44L14.93 50.31A2 2 0 0016 54h44a2 2 0 001.07-3.69L40 36.89v-1.47c.231-.177.479-.331.74-.46A5.49 5.49 0 0044 29.77a6 6 0 10-12 0zM53.13 50H22.87L38 40.75 53.13 50z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Locker.0c633b9b.svg";
export { SvgE2Locker as ReactComponent };